import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { all, call, put, select } from 'redux-saga/effects';
import groupBy from 'lodash/groupBy';
import { selectors, withOffset } from '../../Stream';
import { request } from '../../xhr';
import { MediaSourceType, MediaPopupMode } from '../types';
import { fetchMoreGallectionsDone } from '../actions';
import { getGrusername, getMode } from '../selectors';
import { getGallectionStreamId, getGallectionType } from '../helpers';
import { getStreamInitAction } from './initGallectionStream';
import { ALL_FOLDER_ID, ALL_FOLDER_NAME } from '@wix/da-url';
import { normalizeGallections } from '../../redux/normalizr/helpers';
export function fakeResponse({ params }) {
    if (process.env.NODE_ENV !== 'production') {
        let gallections;
        const putFeaturedFolderFirst = (a, b)=>a.name === 'Featured' ? -1 : 1;
        if (params.type === MediaSourceType.GALLERY) {
            const { galleries, galleriesFolderScraps } = require('@wix/da-sample-data'); // eslint-disable-line global-require
            gallections = galleries.map((gallection)=>_object_spread_props(_object_spread({}, gallection), {
                    permissions: _object_spread_props(_object_spread({}, gallection.permissions), {
                        createFolder: true,
                        editFolder: false,
                        deleteFolder: false
                    })
                }));
            gallections = [
                ...gallections,
                galleriesFolderScraps
            ];
            gallections = gallections.map((gallery, index)=>// make every 5th gallery a subfolder of the second one (after Featured which can't have subfolders)
                index % 5 === 2 // starting from 2 to leave Featured, Scraps folders alone
                 ? _object_spread_props(_object_spread({}, gallery), {
                    parentId: gallections[1].folderId
                }) : gallery);
            const fakeAllFolder = _object_spread_props(_object_spread({}, gallections[2]), {
                parentId: null,
                folderId: ALL_FOLDER_ID,
                name: ALL_FOLDER_NAME
            });
            const paidGallection = _object_spread_props(_object_spread({}, gallections[2]), {
                parentId: null,
                premiumFolderData: {
                    type: 'paid',
                    hasAccess: true,
                    pointsPrice: 800,
                    dollarPrice: 10,
                    numSubscribers: 3
                }
            });
            const watchersGallection = _object_spread_props(_object_spread({}, gallections[3]), {
                parentId: null,
                premiumFolderData: {
                    type: 'watchers',
                    hasAccess: true,
                    pointsPrice: 800,
                    dollarPrice: 10,
                    numSubscribers: 3
                }
            });
            gallections = [
                fakeAllFolder,
                paidGallection,
                watchersGallection,
                ...gallections.slice(4)
            ];
        } else if (params.type === MediaSourceType.STASH) {
            const { stashGallections } = require('@wix/da-sample-data'); // eslint-disable-line global-require
            gallections = stashGallections;
        } else {
            const { collections } = require('@wix/da-sample-data'); // eslint-disable-line global-require
            gallections = collections.sort(putFeaturedFolderFirst);
        }
        if (window.doError) {
            return {
                error: 'invalid_request',
                error_description: 'Not logged in.',
                status: 'error'
            };
        }
        return {
            results: gallections,
            hasMore: true
        };
    }
}
function* fetch(url, params) {
    const response = yield call(request, {
        method: 'get',
        url,
        params
    }, fakeResponse);
    return response;
}
function getStreamFetchSuccessAction(mediaSource, folderId, gallectionFolders) {
    const streamId = getGallectionStreamId(mediaSource, folderId);
    const { result, entities } = normalizeGallections(gallectionFolders);
    return withOffset.actions.fetchSuccess({
        streamId,
        hasMore: false,
        items: result,
        entities
    });
}
function* handleGallectionStreamFetch(action) {
    const { streamId } = action;
    const { offset, limit, mediaSource, folderId, username, mode } = yield select((state)=>({
            offset: withOffset.selectors.getNextOffset(state, streamId),
            limit: selectors.getItemsPerFetch(state, streamId),
            mediaSource: selectors.getStreamParam(state, streamId, 'mediaSource'),
            folderId: selectors.getStreamParam(state, streamId, 'folderId'),
            username: getGrusername(state),
            mode: getMode(state)
        }));
    if (!mediaSource) {
        return;
    }
    var _getGallectionType;
    const params = _object_spread({
        offset,
        limit,
        folderid: folderId,
        type: (_getGallectionType = getGallectionType(mediaSource)) !== null && _getGallectionType !== void 0 ? _getGallectionType : 'collection',
        with_all_folder: mediaSource !== MediaSourceType.STASH,
        with_permissions: mode === MediaPopupMode.MANAGER
    }, username && {
        username
    });
    const response = yield call(fetch, 'gallection/folders', params);
    // TODO: proper error handling
    if (!response) {
        yield put(fetchMoreGallectionsDone(false, mediaSource));
        return;
    }
    const { results } = response;
    if (!results) {
        // TODO: request does not return error message atm
        yield put(withOffset.actions.fetchFailure({
            streamId,
            errorMsg: 'Failed to fetch'
        }));
        yield put(fetchMoreGallectionsDone(false, mediaSource));
        return;
    }
    const foldersByParentId = groupBy(results || [], 'parentId');
    const nonZeroParentIds = Object.keys(foldersByParentId).filter((parentId)=>+parentId);
    if (nonZeroParentIds.length) {
        // if we have folders with subfolders, need to init streams for them
        yield all(nonZeroParentIds.map((parentId)=>put(getStreamInitAction(mediaSource, Number(parentId)))));
    }
    yield all(Object.keys(foldersByParentId).map((parentId)=>{
        const folders = foldersByParentId[parentId];
        return put(getStreamFetchSuccessAction(mediaSource, +parentId, folders));
    }));
    yield put(fetchMoreGallectionsDone(true, mediaSource));
}
export default handleGallectionStreamFetch;
